import React, { useEffect } from 'react';
import { useStore } from 'effector-react';
import { $editingHotspot } from '@stores/editingHotspotStores';
import WidgetsContainer from '@components/PlayerWidgets/WidgetsContainer';
import {
  $playerWidgets,
  $playerWidgetsApi,
  type PlayerWidgetType,
} from '@stores/playerWidgets';
import SysIconWidget from './SysIconWidget';
import { TitleWidget } from './TitleWidget';
import ImageWidget from './ImageWidget';
import { MarkWidget } from './MarkWidget';

function HotspotWidgets() {
  const editing = useStore($editingHotspot);
  const widgets = useStore($playerWidgets);

  useEffect(() => {
    return $playerWidgetsApi.clear;
  }, []);

  if (!editing) return null;
  const renderWidget = (type: PlayerWidgetType) => {
    if (type === 'sysIcon') return <SysIconWidget key="sysIcon" />;
    if (type === 'title') return <TitleWidget key="title" />;
    if (type === 'icon') return <ImageWidget key="icon" />;
    if (type === 'mark') return <MarkWidget key="mark" />;
  };
  return <WidgetsContainer>{widgets.map(renderWidget)}</WidgetsContainer>;
}

export default HotspotWidgets;
